<template>
  <div class="container">
    <div class="profile-tabs">
      <tabs
        :tab-name="['Découvertes', 'Nourriture', 'Autres']"
        :tab-icon="['beach_access', 'food_bank', 'star']"
        plain
        nav-pills-icons
        color-button="success"
      >
        <!-- here you can add your content for tab-content -->
        <template slot="tab-pane-1">
          <div class="md-layout ">
            <div class="md-layout-item md-size-25 ml-auto">
              <img :src="tabPane1[0].image" class="rounded" />
              <img :src="tabPane1[1].image" class="rounded" />
              <img :src="tabPane1[2].image" class="rounded" />
              <img :src="tabPane1[3].image" class="rounded" />
              <img :src="tabPane1[4].image" class="rounded" />
              <img :src="tabPane1[5].image" class="rounded" />
              <img :src="tabPane1[6].image" class="rounded" />
              <img :src="tabPane1[7].image" class="rounded" />
              <img :src="tabPane1[8].image" class="rounded" />
              <img :src="tabPane1[9].image" class="rounded" />
            </div>
            <div class="md-layout-item md-size-25">
              <img :src="tabPane1[10].image" class="rounded" />
              <img :src="tabPane1[11].image" class="rounded" />
              <img :src="tabPane1[12].image" class="rounded" />
              <img :src="tabPane1[13].image" class="rounded" />
              <img :src="tabPane1[14].image" class="rounded" />
              <img :src="tabPane1[15].image" class="rounded" />
              <img :src="tabPane1[16].image" class="rounded" />
              <img :src="tabPane1[17].image" class="rounded" />
            </div>
            <div class="md-layout-item md-size-25 mr-auto">
              <img :src="tabPane1[18].image" class="rounded" />
              <img :src="tabPane1[19].image" class="rounded" />
              <img :src="tabPane1[20].image" class="rounded" />
              <img :src="tabPane1[21].image" class="rounded" />
              <img :src="tabPane1[22].image" class="rounded" />
              <img :src="tabPane1[23].image" class="rounded" />
              <img :src="tabPane1[24].image" class="rounded" />
              <img :src="tabPane1[25].image" class="rounded" />
            </div>
          </div>
        </template>
        <template slot="tab-pane-2">
          <div class="md-layout">
            <div class="md-layout-item md-size-25 ml-auto">
              <img :src="tabPane2[0].image" class="rounded" />
              <img :src="tabPane2[1].image" class="rounded" />
              <img :src="tabPane2[2].image" class="rounded" />
              <img :src="tabPane2[3].image" class="rounded" />
              <img :src="tabPane2[4].image" class="rounded" />
              <img :src="tabPane2[5].image" class="rounded" />
            </div>
            <div class="md-layout-item md-size-25">
              <img :src="tabPane2[6].image" class="rounded" />
              <img :src="tabPane2[7].image" class="rounded" />
              <img :src="tabPane2[8].image" class="rounded" />
              <img :src="tabPane2[9].image" class="rounded" />
              <img :src="tabPane2[10].image" class="rounded" />
              <img :src="tabPane2[11].image" class="rounded" />
              <img :src="tabPane2[12].image" class="rounded" />
            </div>
            <div class="md-layout-item md-size-25 mr-auto">
              <img :src="tabPane2[13].image" class="rounded" />
              <img :src="tabPane2[14].image" class="rounded" />
              <img :src="tabPane2[15].image" class="rounded" />
              <img :src="tabPane2[16].image" class="rounded" />
              <img :src="tabPane2[17].image" class="rounded" />
            </div>
          </div>
        </template>
        <template slot="tab-pane-3">
          <div class="md-layout">
            <div class="md-layout-item md-size-25 ml-auto">
              <img :src="tabPane3[0].image" class="rounded" />
              <img :src="tabPane3[1].image" class="rounded" />
              <img :src="tabPane3[5].image" class="rounded" />
            </div>
            <div class="md-layout-item md-size-25">
              <img :src="tabPane3[2].image" class="rounded" />
              <img :src="tabPane3[3].image" class="rounded" />
              <img :src="tabPane3[4].image" class="rounded" />
            </div>
            <div class="md-layout-item md-size-25 mr-auto">
              <img :src="tabPane3[5].image" class="rounded" />
              <img :src="tabPane3[6].image" class="rounded" />
              <img :src="tabPane3[7].image" class="rounded" />
            </div>
          </div>
        </template>
      </tabs>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
export default {
  components: {
    Tabs
  },
  bodyClass: "profile-page",
  data() {
    return {
      tabPane1: [
        { image: require("@/assets/img/examples/montagne.jpg") },
        { image: require("@/assets/img/examples/plage2.jpg") },
        { image: require("@/assets/img/examples/a1.png") },
        { image: require("@/assets/img/examples/a2.jpeg") },
        { image: require("@/assets/img/examples/a3.jpeg") },
        { image: require("@/assets/img/examples/a4.jpeg") },
        { image: require("@/assets/img/examples/beach.jpeg") },
        { image: require("@/assets/img/examples/vodoun.jpeg") },
        { image: require("@/assets/img/examples/m,.jpeg") },
        { image: require("@/assets/img/examples/Bénin-cité-lacustre.jpeg") },
        { image: require("@/assets/img/examples/nnk.jpeg") },
        {
          image: require("@/assets/img/examples/beaches_near_paris_fb_1_700x367.jpeg")
        },
        { image: require("@/assets/img/examples/blyde-river-canyon.jpeg") },
        {
          image: require("@/assets/img/examples/leopard-trail-blyde-canyon-point-de-vue-krystel-2.jpeg")
        },
        { image: require("@/assets/img/examples/estatua-de-la-libertad.jpeg") },
        {
          image: require("@/assets/img/examples/grand-temple-abu-simbel-1024x678.jpeg")
        },
        {
          image: require("@/assets/img/examples/thumb-circuits-egypte-la-terre-eternelle.jpeg")
        },
        { image: require("@/assets/img/examples/c1.jpeg") },
        {
          image: require("@/assets/img/examples/thumb-circuits-egypte-la-terre-eternelle.jpeg")
        },
        {
          image: require("@/assets/img/examples/ganvie-20181002-juliengerard-FC330-0028.jpeg")
        },
        { image: require("@/assets/img/examples/paris2.jpeg") },
        {
          image: require("@/assets/img/examples/paris3.jpeg")
        },
        {
          image: require("@/assets/img/examples/paris4.jpeg")
        },
        { image: require("@/assets/img/examples/paris5.jpeg") },
        {
          image: require("@/assets/img/examples/paris6.jpeg")
        },
        {
          image: require("@/assets/img/examples/paris7.jpeg")
        },
        { image: require("@/assets/img/examples/paris8.jpeg") },
        {
          image: require("@/assets/img/examples/photo-lieu-448-3.jpeg")
        },
        {
          image: require("@/assets/img/examples/restauParis.jpeg")
        }
      ],
      tabPane2: [
        { image: require("@/assets/img/food/a1.png") },
        { image: require("@/assets/img/food/a4.jpeg") },
        { image: require("@/assets/img/food/a3.jpeg") },
        { image: require("@/assets/img/food/a2.jpeg") },
        { image: require("@/assets/img/food/a5.jpeg") },
        { image: require("@/assets/img/food/a6.jpeg") },
        { image: require("@/assets/img/food/a7.jpeg") },
        {
          image: require("@/assets/img/food/a8.jpeg")
        },
        { image: require("@/assets/img/food/a9.jpeg") },
        {
          image: require("@/assets/img/food/a10.png")
        },
        { image: require("@/assets/img/food/a11.webp") },
        {
          image: require("@/assets/img/food/a12.jpeg")
        },
        {
          image: require("@/assets/img/food/a13.jpeg")
        },
        { image: require("@/assets/img/food/a14.jpeg") },
        {
          image: require("@/assets/img/food/a15.jpeg")
        },
        {
          image: require("@/assets/img/food/a16.jpeg")
        },
        { image: require("@/assets/img/food/a17.jpeg") },
        {
          image: require("@/assets/img/food/a16.jpeg")
        }
      ],
      tabPane3: [
        { image: require("@/assets/img/examples/paris5.jpeg") },
        {
          image: require("@/assets/img/examples/paris6.jpeg")
        },
        {
          image: require("@/assets/img/examples/paris7.jpeg")
        },
        { image: require("@/assets/img/examples/paris8.jpeg") },
        {
          image: require("@/assets/img/examples/photo-lieu-448-3.jpeg")
        },
        {
          image: require("@/assets/img/examples/restauParis.jpeg")
        },
        { image: require("@/assets/img/food/a11.webp") },
        {
          image: require("@/assets/img/food/a12.jpeg")
        },
        {
          image: require("@/assets/img/food/a13.jpeg")
        },
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
